import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import CommandCenter from './components/CommandCenter';
import RunsList from './components/RunsList';
import RunDetail from './components/RunDetail';
import Analytics from './components/Analytics';
import Jobs from './components/Jobs';
import NavBar from './components/NavBar';
import './App.css';

function App() {
    return (
        <Router>
            <div className="App">
                <NavBar />
                <Routes>
                    <Route path="/" element={<CommandCenter />} />
                    <Route path="/runs" element={<RunsList />} />
                    <Route path="/runs/:runId" element={<RunDetail />} />
                    <Route path="/analytics" element={<Analytics />} />
                    <Route path="/jobs" element={<Jobs />} />
                </Routes>
            </div>
        </Router>
    );
}

export default App;